import { Theme } from '@mui/material';

export const styles = {
  dashboardWrapper: {
    position: 'relative',
    zIndex: (theme: Theme) => theme.zIndex.content,
  },
};
